/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthVerifyEmailRequest, AuthVerifyEmailResponse } from '../types/AuthVerifyEmail'

/**
 * POST /auth/verify-email
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::verifyEmail
 */
export async function authVerifyEmail(
	data: AuthVerifyEmailRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthVerifyEmailResponse>> {
	return axiosInstance.post('/auth/verify-email', data, config)
}
